import type { Application } from 'pixi.js';
import type { SceneManager } from './scene-manager';
import type { AudioBus } from './audio';

/**
 * Globally-accessible game context. Scenes call `getContext()` to reach the
 * Pixi Application, scene manager, and audio bus without threading them through
 * every constructor. Set once in main.ts during bootstrap.
 */
export interface GameContext {
  app: Application;
  sceneManager: SceneManager;
  audio: AudioBus;
}

let instance: GameContext | null = null;

export const setContext = (ctx: GameContext): void => {
  instance = ctx;
};

export const getContext = (): GameContext => {
  if (!instance) throw new Error('GameContext not initialized — call setContext first');
  return instance;
};
